var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoriteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8843 6.46065C15.82 6.26235 15.6987 6.08736 15.5356 5.95748C15.3726 5.82759 15.1749 5.74854 14.9672 5.73019L11.0234 5.39018L9.47742 1.71393C9.39693 1.52104 9.26117 1.35626 9.08722 1.24036C8.91328 1.12446 8.70894 1.06262 8.49992 1.06262C8.2909 1.06262 8.08655 1.12446 7.91261 1.24036C7.73867 1.35626 7.60291 1.52104 7.52242 1.71393L5.98113 5.39018L2.03261 5.73218C1.82412 5.7497 1.62544 5.82838 1.46149 5.95837C1.29754 6.08835 1.17562 6.26385 1.11101 6.46285C1.0464 6.66185 1.04198 6.8755 1.09831 7.077C1.15464 7.2785 1.26921 7.45889 1.42765 7.59554L4.42324 10.2133L3.52543 14.1007C3.47795 14.3041 3.4915 14.517 3.56437 14.7128C3.63724 14.9086 3.76621 15.0785 3.93515 15.2014C4.10408 15.3243 4.30549 15.3946 4.5142 15.4037C4.7229 15.4127 4.92963 15.36 5.10855 15.2522L8.49527 13.1936L11.8893 15.2522C12.0682 15.36 12.2749 15.4127 12.4836 15.4037C12.6923 15.3946 12.8938 15.3243 13.0627 15.2014C13.2316 15.0785 13.3606 14.9086 13.4335 14.7128C13.5063 14.517 13.5199 14.3041 13.4724 14.1007L12.5753 10.2093L15.5702 7.59554C15.7286 7.45842 15.843 7.27752 15.8988 7.07559C15.9547 6.87366 15.9497 6.65971 15.8843 6.46065Z",
    fill: "#F2BD00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteFilled);
export default __webpack_public_path__ + "static/media/favoriteFilled.ae36412f21cd7997b3cea47f87ac5943.svg";
export { ForwardRef as ReactComponent };